module.exports = __webpack_public_path__ + "static/media/md.d09118be.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/md.svg
// module id = 1098
// module chunks = 0